export default {
  data() {
    return {
      loading: false,
      success: false,
      server_error: null,
    };
  },
  methods: {
    beforeSubmit() {
      this.loading = true;
      this.server_error = null;
      this.success = false;
    },
    handleSuccess(options) {
      this.loading = false;
      this.success = true;
      setTimeout(() => {
        this.success = false;
      }, 2000);

      if (options && options.toast)
        this.$toasted.show(this.toastHtml(options.toast_text), {
          theme: 'outline',
          position: 'bottom-right',
          duration: 5000,
        });
    },
    handleError(e, options) {
      this.loading = false;
      this.success = false;
      this.server_error = e;
      if (options && options.toast)
        this.$toasted.show(this.toastErrorHtml(options.toast_text), {
          theme: 'danger',
          position: 'bottom-right',
          duration: 5000,
        });
    },
  },
};
